import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { context } from 'bookingbug-core-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private core = AppConfig.settings.addressApi;
  // private apiServer = 'https://staging.bookinglab.co.uk';
  // private apiServer = 'https://api.bookinglab.co.uk';
  private apiServer = AppConfig.settings.addressApi.jrniApi
  private token =
    '735c858f725dc5065d3b5f18e9d8a73540873e030fd8facbaaf2e0c0d802e42f';

  constructor(private http: HttpClient) { }

  // get(postcode) {
  //   const key = this.core.key
  //   return this.http.get(
  //     `https://api.os.uk/search/places/v1/postcode?postcode=${postcode}&key=${key}&dataset=DPA,LPI`
  //   )
  // }

  async getWeekOfBookings(address, company, slot_datetime, weeklyLimit) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      limit: `${company.extra.booking_limit_days}`,
      address: `${address.substring(0, 50)}`, // Address in jrni is capped to 50 characters
      current_date: slot_datetime,
      weeklyLimit: weeklyLimit,
    };

    return await this.http
      .post(`${this.apiServer}/bookingLimit`, body, { headers })
      .toPromise();
  }

  async checkEmailNumber(email, mobile, company) {
    const parent = await company.$get('parent');
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      parent_id: `${parent.id}`,
      email: email ? email : mobile,
      searchType: 'elastic',
    };

    return await this.http
      .post(`${this.apiServer}/findElasticClient`, body, { headers })
      .toPromise();
  }

  async getBookingsForUser(company, parent, email) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}` };
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "parent_id": `${parent.id}`,
      "email": `${email}`,
    }

    return await this.http.post(`${this.apiServer}/findElasticClientSecure`, body, { headers }).toPromise();
  }

  async checkForDoubleBooking(company, slot, email = null, mobile = null) {
    const parent = await company.$get('parent');
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      parent_id: `${parent.id}`,
      current_date: slot,
    };

    if (email) {
      body['email'] = email;
    } else {
      body['mobile'] = mobile;
    }

    // return this.http.post('https://staging.bookinglab.co.uk/unavailableTimes', body, { headers }).toPromise();
    return this.http
      .post(`${this.apiServer}/unavailableTimes`, body, { headers })
      .toPromise();
  }

  async checkSlotAvailability(company, slot) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      slot: slot,
    };

    return this.http
      .post(`${this.apiServer}/slotAvailability`, body, { headers })
      .toPromise();
  }

  async getAddressException() {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
    };

    return await this.http
      .post(`${this.apiServer}/addressException`, body, { headers })
      .toPromise();
  }

  async checkBookingLimit(company, matchString, slot, service) {
    console.log(service);
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      match_string: `${matchString.trim()}`,
      slot: `${slot}`,
      max_time: service.max_advance_period,
    };

    return await this.http
      .post(`${this.apiServer}/checkBookingLimit`, body, { headers })
      .toPromise();
  }

  async updateBookingLimit(company, matchString, slot) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      match_string: `${matchString.trim()}`,
      slot: `${slot}`,
    };

    return await this.http
      .post(`${this.apiServer}/updateBookingLimit`, body, { headers })
      .toPromise();
  }

  async getConfig(site: string, comp: string) {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = {
      'Content-Type': 'application/json',
      Clienttoken: environment.clientToken,
    };
    const body = {
      client: site,
      company: comp,
    };

    return await this.http
      .post(`${environment.apiServer}/config`, body, { headers })
      .toPromise();
  }

  async getToken(site: string, comp: string) {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = {
      'Content-Type': 'application/json',
      Clienttoken: environment.clientToken,
    };
    const body = {
      client: site,
      company: comp,
    };

    return await this.http
      .post(`${environment.apiServer}/token`, body, { headers })
      .toPromise();
  }

  async getWasteLimit(parent_id: number, matchString: string, date: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Clienttoken: environment.clientToken,
      };
      return await this.http
        .get(
          `${environment.apiServer}/waste?company=${parent_id}&matchString=${matchString}&date=${date}`,
          { headers }
        )
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getAlertTableStatus(reg) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
      regs: [reg],
    };

    return await this.http
      .post(`${this.apiServer}/anpr/search`, body, { headers })
      .toPromise();
  }

  async getBanned() {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
    };
    return await this.http
      .post(`${this.apiServer}/anpr/banned`, body, { headers })
      .toPromise();
  }

  async getObserved() {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
    };
    return await this.http
      .post(`${this.apiServer}/anpr/observe`, body, { headers })
      .toPromise();
  }

  async getVehicleDetails(vehiclereg) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
    };

    return await this.http
      .post(`${this.apiServer}/dvlaVehicleEnquiry/${vehiclereg}`, body, {
        headers,
      })
      .toPromise();
  }

  async searchArea(query, area) {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = {
      'X-API-Key': 'rkzFw3Pv9Gnqk1gtny9V',
    };

    return await this.http
      .get(`https://geoapi.dorsetcouncil.gov.uk/v1/Places/Address?query=${query}&searchArea=${area}`, { headers })
      .toPromise();
  }

  async passwordReset(email: string, companyId: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "email": email
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/forgot-password`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async checkEmailAndName(email, company) {
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };

    return await this.http.get(`${environment.apiServer}/company/${company}/client/email/${email}`, { headers }).toPromise();
  }


  async saveHwrcAddressForm(client_id: string, companyId: any, body: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "body": JSON.stringify(body)
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/address`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async saveHwrcVehicleForm(client_id: string, companyId: any, body: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "body": JSON.stringify(body)
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/vehicle`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getHwrcVehicleForm(client_id: string, companyId: any, no: number) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/vehicle?no=${no}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getHwrcAddressForm(client_id: string, companyId: any, no: number) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/client/${client_id}/hwrc/address?no=${no}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async generateSSOToken(companyId: any, first_name: any, last_name: any, email: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': `${environment.clientToken}`
      };

      const bodyData = {
        first_name: `${first_name}`,
        last_name: `${last_name}`,
        email: `${email}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async ssoLogin(companyId: any, token: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': `${environment.clientToken}`,
        'x-app-id': AppConfig.settings.core.x_app_id
      };

      const bodyData = {
        token: `${token}`
      };

      return await this.http.post(`${environment.apiServer}/company/${companyId}/sso/login`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async passwordResetTokenBased(email: string, companyId: any, path: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      const bodyData = {
        "email": email,
        "token_based_reset": true,
        "path": `${path}`
      }
      return await this.http.post(`${environment.apiServer}/company/${companyId}/forgot-password`, bodyData, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async get(postcode) {
    const key = this.core.key
    return await this.http.get(
      `https://api.os.uk/search/places/v1/postcode?postcode=${postcode}&key=${key}&dataset=DPA,LPI`
    ).toPromise();
  }


  async getFormSchema(formId: string, companyId: any, companyName: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      const data = {
        company: companyId,
        client: `${companyName}`,
        form_name: `${formId}`
      };
      return await this.http.post(`${environment.apiServer}/form/schema`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async getBookings(companyId: number, memberId: number) {

    const authToken = localStorage.getItem('auth_token');

    try {
      // const headers = {
      //   'Content-Type': 'application/json',
      //   'x-member-id': `${memberId}`,
      //   'authtoken': authToken,
      //   'x-company-id': `${companyId}`,
      //   'clienttoken': environment.clientToken

      // };
      const headers = {
        'Content-Type': 'application/json',
        'X-BL-TOKEN': `${this.token}`,
        'authtoken': authToken,
        'x-member-id': `${memberId}`,
        'x-company-id': `${companyId}`,
        'clienttoken': environment.clientToken,
        'x-app-id': AppConfig.settings.core.x_app_id
      };

      return await this.http.get(`${environment.apiServer}/company/${companyId}/member/${memberId}/bookings`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async cancelBookings(booking, member) {

    const authToken = localStorage.getItem('auth_token');
    const memberId = member.id;
    const companyId = booking.company_id
    const bookingId = booking.id;

    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
      'authtoken': authToken,
      'x-member-id': `${memberId}`,
      'x-company-id': `${companyId}`,
      'clienttoken': environment.clientToken
    };

    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${companyId}`,
      "booking_id": `${bookingId}`
    }
    return this.http.post(`${this.apiServer}/cancelMultiBookings`, body, { headers }).toPromise();
  }


  async questions(detailgroupid: any, companyid: any) {

    // const authToken = this.dataStore.authToken;
    // const memberid = this.dataStore.member.id;

    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };

      return await this.http.get(`${environment.apiServer}/company/${companyid}/questions/${detailgroupid}`, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async moveBooking(booking: any, member: any, slot: any, duration) {

    const authToken = localStorage.getItem('auth_token');
    const memberId = member.id;
    const companyId = booking.company_id
    const bookingid = booking.id;
    const datetime = new Date(slot);

    try {
      const headers = {
        'Content-Type': 'application/json',
        'X-BL-TOKEN': `${this.token}`,
        'authtoken': authToken,
        'x-member-id': `${memberId}`,
        'x-company-id': `${companyId}`,
        'x-app-id': AppConfig.settings.core.x_app_id,
        'clienttoken': environment.clientToken
      };

      const body = {
        date: datetime.toISOString().split('T')[0],
        time: datetime.getMinutes() + (datetime.getHours() * 60),
        "duration": duration //booking.duration / 60 / 60,
      };

      return await this.http.put(`${environment.apiServer}/company/${companyId}/member/${memberId}/bookings/${bookingid}/move`, body, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async updateBooking(booking_id, company_id, body) {
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };

    return await this.http.put(`${environment.apiServer}/company/${company_id}/booking/${booking_id}`, body, { headers }).toPromise();
  }

  // Check whether the DVLA vehicle lookup service is currently available.
  // Returns { status: true } when the lookup is healthy. On staging we hit a
  // separate status key (-staging) so it can be toggled without a new build.
  async getDvlaLookupStatus(isStaging: boolean) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`,
    };
    const body = {
      host: `${context.apiUrl}`,
    };

    return await this.http
      .post(`${this.apiServer}/serviceStatus/dvla${isStaging ? '-staging' : ''}`, body, { headers })
      .toPromise();
  }

  async getServiceStatus(serviceName: string) {
    const headers = {
      'Content-Type': 'application/json',
      'X-BL-TOKEN': `${this.token}`
    };
    const body = {
      host: `${context.apiUrl}`,
    };

    return await this.http
      .post(`${this.apiServer}/serviceStatus/${serviceName}`, body, { headers })
      .toPromise();
  }

  async getConfigByAppConfig() {
    const site = new URL(AppConfig.settings.apiServer.api_url).hostname.split('.')[0];
    const company = AppConfig.settings.core.company_id;
    return this.getConfig(site, company);
  }
}
